import React from 'react';
import '../styles/CustomCard.css';

const CustomCard = ({
  // Legacy props for backward compatibility
  title,
  description,
  titleIcon,
  descriptionIcon,
  titleIconSize = 'medium',
  descriptionIconSize = 'small',

  // New flexible JSX element props
  topComponent,
  bottomComponent,
  topIcon,
  bottomIcon,

  // Common props
  variant = 'primary', // 'primary', 'secondary', or 'transparent'
  className = '',
  onClick,
  ...props
}) => {
  const cardClasses = `
    custom-card 
    custom-card--${variant} 
    ${onClick ? 'custom-card--clickable' : ''} 
    ${className}
  `.trim();

  const titleIconClasses = `
    custom-card__title-icon 
    custom-card__title-icon--${titleIconSize}
  `.trim();

  const descriptionIconClasses = `
    custom-card__description-icon 
    custom-card__description-icon--${descriptionIconSize}
  `.trim();

  // Determine which content to render
  const hasNewProps = topComponent || bottomComponent || topIcon || bottomIcon;
  const hasLegacyProps = title || description;

  return (
    <div className={cardClasses} onClick={onClick} {...props}>
      <div className="custom-card__content">
        {/* New flexible layout */}
        {hasNewProps && (
          <>
            {(topIcon || topComponent) && (
              <div className="custom-card__top-section">
                {topIcon && <div className="custom-card__top-icon">{topIcon}</div>}
                {topComponent && <div className="custom-card__top-component">{topComponent}</div>}
              </div>
            )}

            {(bottomIcon || bottomComponent) && (
              <div className="custom-card__bottom-section">
                {bottomIcon && <div className="custom-card__bottom-icon">{bottomIcon}</div>}
                {bottomComponent && <div className="custom-card__bottom-component">{bottomComponent}</div>}
              </div>
            )}
          </>
        )}

        {/* Legacy layout for backward compatibility */}
        {!hasNewProps && hasLegacyProps && (
          <>
            {title && (
              <div className="custom-card__title-container">
                {titleIcon && <div className={titleIconClasses}>{titleIcon}</div>}
                <h3 className="custom-card__title">{title}</h3>
              </div>
            )}

            {description && (
              <div className="custom-card__description-container">
                {descriptionIcon && <div className={descriptionIconClasses}>{descriptionIcon}</div>}
                <p className="custom-card__description">{description}</p>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default CustomCard;
